// Permission map for the Advanced Analytics dashboard widgets
// (src/views/dashboard/AnalyticsView). This is a UI-level RBAC layer on top
// of the existing user.data.permissions object (see src/router/routeGuard.js
// and src/const/links.js for the pattern this follows).
//
// Each entry maps a widget to a unique permission identifier. Widgets are
// grouped into logical categories so they can be managed together in the
// Roles admin UI once these permissions are added to the backend catalog.
//
// See docs/specs/<date>-analytics-widget-permissions/ for the full spec.

export const ANALYTICS_PERMISSION_CATEGORIES = {
  MESSAGING: "messaging",
  PERFORMANCE: "performance",
  AI_ANALYSIS: "ai_analysis",
};

export const ANALYTICS_PERMISSION_CATEGORY_LABELS = {
  [ANALYTICS_PERMISSION_CATEGORIES.MESSAGING]: "Mensajería",
  [ANALYTICS_PERMISSION_CATEGORIES.PERFORMANCE]: "Rendimiento",
  [ANALYTICS_PERMISSION_CATEGORIES.AI_ANALYSIS]: "IA y Análisis",
};

// key -> { permission, label, category, implemented }
// `implemented: false` marks permissions reserved for widgets that do not
// exist in the codebase yet (e.g. Costos de IA), so the identifier is
// defined ahead of time without wiring a PermissionGate to a component.
export const ANALYTICS_WIDGET_PERMISSIONS = {
  MESSAGES_SUMMARY: {
    permission: "analytics:messages:view",
    label: "Resumen de Mensajes",
    category: ANALYTICS_PERMISSION_CATEGORIES.MESSAGING,
    implemented: true,
  },
  CLIENTS_SUMMARY: {
    permission: "analytics:clients:view",
    label: "Resumen de Clientes",
    category: ANALYTICS_PERMISSION_CATEGORIES.PERFORMANCE,
    implemented: true,
  },
  AGENTS_PERFORMANCE: {
    permission: "analytics:agents:view",
    label: "Rendimiento de Agentes",
    category: ANALYTICS_PERMISSION_CATEGORIES.PERFORMANCE,
    implemented: true,
  },
  CAMPAIGN_EFFECTIVENESS: {
    permission: "analytics:campaigns:view",
    label: "Efectividad de Campañas",
    category: ANALYTICS_PERMISSION_CATEGORIES.PERFORMANCE,
    implemented: true,
  },
  CLIENT_SOURCES: {
    permission: "analytics:client-sources:view",
    label: "Análisis de Conversaciones y Fuentes de Conversaciones",
    category: ANALYTICS_PERMISSION_CATEGORIES.AI_ANALYSIS,
    implemented: true,
  },
  FACEBOOK_FORMS: {
    permission: "analytics:facebook-forms:view",
    label: "Formularios de Facebook",
    category: ANALYTICS_PERMISSION_CATEGORIES.AI_ANALYSIS,
    implemented: true,
  },
  AI_COSTS: {
    permission: "analytics:ai-costs:view",
    label: "Costos de IA",
    category: ANALYTICS_PERMISSION_CATEGORIES.AI_ANALYSIS,
    implemented: false,
  },
};

// Convenience flat list of every permission identifier defined above.
export const ANALYTICS_PERMISSIONS_LIST = Object.values(
  ANALYTICS_WIDGET_PERMISSIONS
).map((widget) => widget.permission);

export default ANALYTICS_WIDGET_PERMISSIONS;
